export abstract class ABNT {

    /** 
     * ## NBR5891 de 1977
     * 
     * ### OBJETIVO
     * Esta norma tem por fim estabelecer as regras de arredondamento na Numeração Decimal.
     * 
     * ### REGRAS DE ARREDONDAMENTO
     * 
     * - Quando o algarismo imediatamente seguinte ao último algarismo a ser conservado for inferior a 5, o último algarismo a ser conservado permanecerá sem modificação. P. ex.: 1,3 3 arredondado à primeira decimal tornar-se-à: 1,3.
     * - Quando o algarismo imediatamente seguinte ao último algarismo a ser conservado for superior a 5, ou, sendo 5, for seguido de no mínimo um algarismo diferente de zero, o último algarismo a ser conservado deverá ser aumentado de uma unidade.
     * P.ex.: 1,6 6 arredondado à primeira decimal tornar-se-à: 1,7; 4,850 5 arredondados à primeira decimal tornar-se-ão: 4,9.
     * - Quando o algarismo imediatamente seguinte ao último algarismo a ser conservado for 5 seguido de zeros, dever-se-á arredondar o algarismo a ser conservado para o algarismo par mais próximo. Conseqüentemente, o último algarismo a ser retirado, se for ímpar, aumentará uma unidade. P.ex.: 4,550 0 arredondados à primeira decimal tornar-se-ão: 4,6.
     * - Quando o algarismo imediatamente seguinte ao último a ser conservado for 5 seguido de zeros, se for par o algarismo a ser conservado, ele permanecerá sem modificação. P.ex.: 4,850 0 arredondados à primeira decimal tornar-se-ão: 4,8.
     * 
     * ### EXEMPLOS DE ARREDONDAMENTO
     * 
     * | Entrada   | Casas | Saída |
     * |----------:|------:|------:|
     * | 1.333     | 1     | 1.3   |
     * | 1.666     | 1     | 1.7   |
     * | 4.850     | 1     | 4.8   |
     * | 4.550     | 1     | 4.6   |
     * | 4.850     | 1     | 4.8   |
     * | 0.342     | 2     | 0.34  |
     * | 0.346     | 2     | 0.35  |
     * | 0.3452    | 2     | 0.35  |
     * | 0.3450    | 2     | 0.34  |
     * | 0.332     | 2     | 0.33  |
     * | 0.336     | 2     | 0.34  |
     * | 0.3352    | 2     | 0.34  |
     * | 0.3350    | 2     | 0.34  |
     * | 0.3050    | 2     | 0.30  |
     * | 0.3150    | 2     | 0.32  |
     * | 0.3050001 | 2     | 0.31  |
     */
    static round(value: number, decimalPoints: number): number {
        const sign = value < 0 ? "-" : "+";
        if (typeof value !== 'number') {
            throw new Error(`Invalid argument for 'value'`, { cause: `${value} is not a number` });
        }
        if (!Number.isInteger(decimalPoints)) {
            throw new Error(`Invalid argument for 'decimalPoints'`, { cause: `${decimalPoints} is not an integer` });
        }
        if (decimalPoints < 0) {
            throw new Error(`Invalid argument for 'decimalPoints'`, { cause: `${decimalPoints} is not positive` });
        }

        const [integerPart, decimalPart] = value
            .toString()
            .replace('-', '')
            .split('.')
            .map(str => str.split('').map(char => parseInt(char)));

        if (!decimalPart || decimalPart.length <= decimalPoints) {
            // value already rounded
            return value;
        }

        let integerValue = Number(integerPart.join(''));
        let decimalValue = Number(decimalPart.slice(0, decimalPoints).join(''));

        if (decimalPart[decimalPoints] > 5) { // round up
            decimalValue += 1;
        } else if(decimalPart[decimalPoints] === 5) { 
            const fiveIsLast = decimalPart.length <= decimalPoints + 1;
            if (fiveIsLast) { // round to even
                decimalValue += decimalValue % 2;
            } else { // round up
                decimalValue += 1;
            }
        }

        if (decimalValue.toString().length > decimalPoints) {
            // overflow
            decimalValue = 0;
            integerValue += 1;
        }

        return Number(sign + integerValue + '.' + decimalValue);
    }

}
